import { useMutation, useQuery } from "@tanstack/react-query";
import {
  CalendarListParams,
  CalenderItem,
  DefaultErrorResponse,
} from "@/types";
import API_ENDPOINTS from "@/data/client/endpoints.ts";
import client from "@/data/client";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import routes from "@/config/routes.ts";
import { AxiosError } from "axios";

export function useCalendarList(params: Partial<CalendarListParams>) {
  const { data, isLoading, error } = useQuery<CalenderItem[], Error>(
    [API_ENDPOINTS.CALENDAR_LIST, params],
    ({ queryKey }) =>
      client.diploma.calendarList(Object.assign({}, queryKey[1])),
  );
  return {
    calendar: data,
    isLoading,
    error,
  };
}

export function useBookDiplomaRequestMutation(callback?: () => void) {
  const navigate = useNavigate();

  return useMutation(client.diploma.bookRequest, {
    onSuccess: (data) => {
      if (data.success) {
        enqueueSnackbar("Diploma Request booked successfully", {
          variant: "success",
        });
        if (callback) {
          callback();
        }
        navigate(routes.agenda, {
          replace: true,
        });
      } else {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      }
    },
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}
